var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-8 w-8 flex justify-center items-center rounded-full bg-gray-900 text-white border border-white-900",attrs:{"title":_vm.name}},[_c('div',[_vm._v(" "+_vm._s(_vm.initials)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }